import React, { Component } from 'react';
import { IconButton, Checkbox, Menu, MenuItem, Popover, Divider } from '@material-ui/core';
import cssClasses from './TransactionsMenu.css';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import { PORTAL_MAIN_URL } from '../../Actions/types';

class OptionMenu extends Component {
    state = { menuOpen: null, showHelp: null };

    handleClick = event => {
        this.setState({ menuOpen: event.currentTarget });
    };

    handleClose = () => {
        this.setState({ menuOpen: null, showToolTip: null });
    };

    handleOpenHelp = (event) => {
        this.setState({ showHelp: event.currentTarget });
    };

    handleCloseHelp = () => {
        this.setState({ showHelp: null });
    };

    showModal = (value) => {
        this.props.showModal(value);
        this.setState({ menuOpen: null, showToolTip: null });
    }

    resetColumns = (refreshGrid) => {
        localStorage.removeItem('columnPxWidths');
        this.setState({ menuOpen: null, showToolTip: null });
        refreshGrid();
    }

    showRemoveModal = () => {
        this.props.showRemoveModal();
        this.setState({ menuOpen: null, showToolTip: null });
    }

    backToPortal = () => {
        window.location.href = PORTAL_MAIN_URL;
    }

    openLink = link => {
        window.open(link, "_blank");
    }

    render() {
        const { toggleFilter, toggleDisplayAccount, toggleEditableDescription, toggleTaxTracking, refreshGrid, hasFeeds, displayAccount, editableDescription, taxTracking, isR1, isRah, isTransactionToRemove, codingErrors } = this.props;
        const { menuOpen, showHelp } = this.state;
        const CloseTooltip = withStyles({ tooltip: { marginBottom: -1, fontSize: 13 } })(Tooltip);
        const newFeatureLink = 'https://ideas.reckon.com/?category=6895989533618438235';
        
        const helpLink = isR1 
          ? 'https://help.reckon.com/article/xubasickql-fast-coding' 
          : 'https://help.reckon.com/article/ubk4hlz8ch-bank-data-fast-coding';
               
        return <div>
          {codingErrors > 0 &&
            <span className={`fa-stack fa-1x ${cssClasses.commentsIcon}`} style={{ width: '20px', marginRight: 5, marginTop: 15 }} onClick={() => {}}>
              <i className={`fa fa-square fa-stack-2x ${cssClasses.comment_icon}`} />
              <strong className={`fa-stack-1x ${cssClasses.comment_value}`}>{codingErrors > 9 ? '9+': codingErrors}</strong>
            </span>}
            <Popover id='Show-Help' open={Boolean(showHelp)} anchorEl={showHelp} onClose={this.handleCloseHelp} anchorOrigin={{ vertical: 'center', horizontal: 'left' }} transformOrigin={{ vertical: 'center', horizontal: 'right' }}>
              <div className={cssClasses.tooltip}>
                For more information on Fast coding
                <br />
                please view our <a target='_blank' rel='noopener noreferrer' href={helpLink}>
                  online help document
                </a>
              </div>
            </Popover>

            <IconButton tabIndex={-1} aria-label='Help' onClick={this.handleOpenHelp}>
              <i className='fas fa-question-circle' />
            </IconButton>
            {!isR1 && <CloseTooltip title='Rule' placement='top'> 
                <IconButton aria-label='rule' onClick={this.props.showRules}>
                  <i className='fas fa-sm fa-flag' />
                </IconButton>
              </CloseTooltip>}

            {hasFeeds && <IconButton tabIndex={-1} aria-label='Options' aria-owns={Boolean(menuOpen) ? 'long-menu' : undefined} aria-haspopup='true' onClick={this.handleClick}>
              <i className='fas fa-ellipsis-v' />
            </IconButton>}
            <Menu id='optionMenu' anchorEl={menuOpen} open={Boolean(menuOpen)} onClose={this.handleClose}>
              <MenuItem onClick={toggleDisplayAccount}>
                <Checkbox checked={displayAccount} onChange={toggleDisplayAccount} value='checkedB' color='primary' />
                Display by account code
              </MenuItem>
              {isRah && <MenuItem onClick={toggleTaxTracking}>
                  <Checkbox checked={taxTracking} value='checkedB' color='primary' />
                  Are you Registered for GST?
                </MenuItem>}
              <MenuItem onClick={toggleEditableDescription}>
                <Checkbox checked={editableDescription} onChange={toggleEditableDescription} value='checkedB' color='primary' />
                Editable Description
              </MenuItem>
              <Divider light />
              <MenuItem onClick={() => this.showModal('columns')}>
                <div className={cssClasses.icon}>
                  <i className='fas fa-columns' />
                </div>
                <div>Display Columns</div>
              </MenuItem>
              <MenuItem onClick={() => this.resetColumns(refreshGrid)}>
                <div className={cssClasses.icon}>
                  <i className='fas fa-undo' />
                </div>
                <div>Reset Columns Size</div>
              </MenuItem>

              <div>
                  <Divider light />
                  <MenuItem onClick={() => this.showModal('upload')}>
                    <div className={cssClasses.icon}>
                      <i className='fas fa-upload' />
                    </div>
                    <div>Upload Transactions</div>
                  </MenuItem>
                   <MenuItem onClick={() => this.showModal('export')}>
                    <div className={cssClasses.icon}>
                      <i className='fas fa-download' />
                    </div>
                    <div>Export Transactions</div>
                  </MenuItem>
                  <MenuItem disabled={!isTransactionToRemove} onClick={this.showRemoveModal}>
                    <div className={cssClasses.icon}>
                      <i className='fas fa-trash-alt' />
                    </div>
                    <div>Remove Transactions</div>
                  </MenuItem>
                </div>
              <div>
                  <Divider light />
                  {<MenuItem onClick={() => this.openLink(newFeatureLink)}>
                      <div className={cssClasses.icon}>
                        <i className='fas fa-lightbulb' />
                      </div>
                      <div>Suggest New Features</div>
                    </MenuItem>}
                  {isRah && <MenuItem onClick={this.backToPortal}>
                      <div className={cssClasses.icon}>
                        <i className='fas fa-sign-out-alt' />
                      </div>
                      <div>Back to Portal</div>
                    </MenuItem>}
                </div>
            </Menu>
          </div>;
    }
}

export default OptionMenu


// WEBPACK FOOTER //
// ./src/components/TransactionsMenu/OptionMenu.js